import React, { useState } from 'react'
import { Job } from 'newComponents'

const nullCheck = (string) => {
  if (!string) {
    return 'Uncategorized'
  }
  return string
}

const Jobs = (props) => {
  const { jobs } = props
  const [selectedTeam, setSelectedTeam] = useState('all')

  return (
    <>
      {jobs ? (
        <>
          <div className="jobs-teams has-text-centered-tablet">
            <button type="button" name="all" className={`btn ${selectedTeam === 'all' ? 'active' : ''}`}
              onClick={(e) => setSelectedTeam(e.target.name)}>All</button>
            <CreateTeams jobs={jobs} setSelectedTeam={setSelectedTeam} selectedTeam={selectedTeam} />
          </div>
          <div className="jobs-list columns is-multiline">
            <CreateJobs jobs={jobs} selectedTeam={selectedTeam} />
          </div>
        </>
      ) : (
        <p className="has-text-centered subtitle">
          Looks like the page isn’t loading correctly. Try refreshing your browser or you can also find open positions{' '}
          <a href="https://boards.greenhouse.io/launchdarkly">here</a>.
        </p>
      )}
    </>
  )
}

const CreateTeams = ({ jobs, setSelectedTeam, selectedTeam }) => {
  const filterTeams = (accumulator, job) => {
    const currentTeamTitle = job.metadata[1].value
    if (accumulator.includes(currentTeamTitle) === false) {
      return [...accumulator, currentTeamTitle]
    }
    return accumulator
  }

  const teams = jobs.reduce(filterTeams, [])

  const selectTeam = (e) => {
    e.preventDefault()
    setSelectedTeam(e.target.name)
  }

  return teams.map((team) => {
    const teamTitle = nullCheck(team)

    return (
      <button type="button" key={teamTitle} className={`btn ${selectedTeam === teamTitle ? 'active' : ''}`} name={teamTitle} onClick={selectTeam}>
        {teamTitle}
      </button>
    )
  })
}

const CreateJobs = ({ jobs, selectedTeam }) =>
  jobs.map((job) => {
    let teamTitle = job.metadata[1].value
    teamTitle = nullCheck(teamTitle)
    const { content } = job

    // format to html
    const strip = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html')
      return doc.body.textContent || ''
    }

    const strippedContent = strip(content)
    // remove html tags
    const formattedContent = strippedContent.replace(/(<([^>]+)>)/gi, '')
    // remove white spaces
    const description = formattedContent.replace(/&nbsp;/g,' ')

    return (
      <Job
        job={job}
        selectedTeam={selectedTeam}
        key={job.id}
        team={teamTitle}
        nullCheck={nullCheck}
        description={description}
      />
    )
  })

export default Jobs
